<template>
  <div
    class="bg-gray-200 border-t-2 border-t-gray-300 p-8 grid grid-cols-1 lg:grid-cols-3 gap-8"
  >
    <div
      class="lg:col-span-2 flex flex-col items-start xl:flex-row gap-y-4 gap-x-8"
    >
      <img
        class="inline h-12 object-contain lg:h-16 2xl:h-20"
        :src="logo"
        alt="Mirus Research"
      />
      <div class="flex flex-col gap-y-2">
        <p class="font-bold text-balance">
          Proudly providing a Content Management Platform for State Farm and
          Approved Third-Party Vendors
        </p>
        <p class="text-sm">
          All services and associated support of the CMP are provided by Mirus
          Research Inc. State Farm is not responsible for CMP or its related
          services.
        </p>
      </div>
    </div>
    <div class="col-span-1">
      <ul class="w-fit space-y-1">
        <div class="font-semibold">Contact Support</div>
        <li>
          <a href="tel:+18778283131" aria-label="Call toll-free">
            1-877-828-3131
          </a>
        </li>
        <li>
          <a href="mailto:support@mysfdomain.com"> support@mysfdomain.com </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import logo from "@/components/icons/logos/mirus-logo-orange-black.png";
</script>
